import classnames from 'classnames';

export const themes = {
  default: ({ hasColumnLayout, hasValue, isDisabled, isReadOnly, validationState }) => ({
    thRoot: hasColumnLayout ? 'flex flex-col text-center' : 'flex items-center justify-between',
    thLabel: classnames('text-base', {
      'rtl:mr-3': !hasColumnLayout,
      'mb-1': hasColumnLayout,
      'text-gray-darker':
        validationState === 'NOT_VALIDATED' && hasValue && !isReadOnly && !isDisabled,
      'text-emerald': validationState === 'IS_VALID' && hasValue && !isReadOnly && !isDisabled,
      'text-red': validationState === 'IS_INVALID' && hasValue && !isReadOnly && !isDisabled,
    }),
    thNotes: 'text-xs text-gray-medium',
    thInputs: 'flex-shrink-0',
    thInput: classnames(
      'reset-input reset-input-number mx-1 px-1 text-center text-base outline-custom',
      {
        'font-bold': hasValue && !isReadOnly && !isDisabled,
        'text-blue': validationState === 'NOT_VALIDATED' && hasValue && !isReadOnly && !isDisabled,
        'text-emerald': validationState === 'IS_VALID' && hasValue && !isReadOnly && !isDisabled,
        'text-red': validationState === 'IS_INVALID' && hasValue && !isReadOnly && !isDisabled,
      },
    ),
    thButton:
      'reset-button cursor-default bg-gray-lighter border-gray-lighter rounded-tiny h-full text-gray-medium transition-colors',
    thButtonEnabled:
      'cursor-pointer focus:bg-turquoise hover:bg-turquoise focus:border-turquoise hover:border-turquoise focus:text-white hover:text-white',
    thButtonStyle: { height: '1.875rem', width: '1.875rem' },
    thButtonIconWidth: '0.625rem',
  }),
};
